import Dialog from "@mui/material/Dialog";
import PropTypes from "prop-types";
import DialogTitle from "@mui/material/DialogTitle";
import {DialogActions, DialogContent, TextField} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import Button from "@mui/material/Button";
import {useEffect, useState} from "react";
import {
    useApproveTransferMutation,
    useRejectTransferMutation
} from "../../core/api/transfer-request-api";
import ResponseDialog from "../ResponseDialog";


export * as React from 'react'

export default function ApproveTransferConfirmDialog(props) {
    const {onClose, open, requestId} = props;
    const [approveRequest, approveRequestResponse] = useApproveTransferMutation();
    const [rejectRequest, rejectRequestResponse] = useRejectTransferMutation();

    const [state, setState] = useState({
        comment: "",
        isConfirmResponseDialogOpen: false,
        isConfirmResponseReady: false,
        isRequestLoading: false,
        errors: {}
    })

    useEffect(() => {
        const isReadyToDialog = (approveRequestResponse.status === 'rejected' ||
            approveRequestResponse.status === 'fulfilled') || (rejectRequestResponse.status === 'rejected' ||
            rejectRequestResponse.status === 'fulfilled')
        if (isReadyToDialog) {
            props.refetch();
            props.refetchBudgets();
            setState({
                ...state,
                isConfirmResponseReady: true,
                isConfirmResponseDialogOpen: true,
                isRequestLoading: false
            })
        }
    }, [approveRequestResponse])

    const handleOnClose = () => {
        setState({
            ...state,
            isConfirmResponseReady: false,
            isConfirmResponseDialogOpen: false
        })
        onClose(true);
    }

    const handleApproveRequest = async () => {
        setState({
            ...state,
            isRequestLoading: true
        })
        approveRequest({
            transferId: requestId,
            status: "APPROVED",
            comment: state.comment ? state.comment : ""
        })
    }

    const handleRejectRequest = async () => {
        if (validateRequiredFields()) {
            setState({
                ...state,
                isRequestLoading: true
            })
            rejectRequest({
                transferId: requestId,
                status: "REJECTED",
                comment: state.comment
            })
        }
    }

    const validateRequiredFields = () => {
        let errors = {};
        if (!props.isApprove && state.comment.trim() === '') {
            errors = {...errors, comment: true}
        }
        setState({
            ...state,
            errors: errors,
        })

        return Object.keys(errors).length === 0;
    }

    return <Dialog onClose={handleOnClose}
                   open={open}>
        <DialogTitle>
            {"Confirm action"}
        </DialogTitle>
        <DialogContent>
            {
                props.isApprove ? "Are you sure you want to approve the request?" :
                "Are you sure you want to reject the request?"
            }
            <TextField
                sx={{mt: 2}}
                value={state.sum}
                id="reject-reason"
                label={props.isApprove? "You can add a comment for the accrual here": "Cancellation reason"}
                variant="outlined"
                color="warning"
                onChange={(event) => {
                    setState({
                        ...state,
                        errors: {},
                        comment: event.target.value
                    });
                }}
                fullWidth
                error={state.errors.comment}
                helperText={state.errors.comment
                    ? "This field cannot be empty"
                    : ""}
            />
        </DialogContent>
        <DialogActions>
            <Button
                size="small"
                color="secondary"
                onClick={handleOnClose}>
                Cancel
            </Button>
            {props.isApprove ?
                <LoadingButton
                    size="small"
                    onClick={handleApproveRequest}
                    loading={state.isRequestLoading}
                    variant="outlined"
                    color="warning"
                >
                    Yes
                </LoadingButton> :
                <LoadingButton
                    size="small"
                    onClick={handleRejectRequest}
                    loading={state.isRequestLoading}
                    variant="outlined"
                    color="warning"
                >
                    Yes
                </LoadingButton>
            }

        </DialogActions>

        {state.isConfirmResponseReady &&
            <ResponseDialog onClose={handleOnClose}
                            open={state.isConfirmResponseDialogOpen}
                            responseData={approveRequestResponse}
                            label={"Accrual confirmation"}/>
        }

    </Dialog>
}

ApproveTransferConfirmDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    requestId: PropTypes.string.isRequired,
    isApprove: PropTypes.bool.isRequired,
    refetch: PropTypes.func.isRequired,
    refetchBudgets: PropTypes.func.isRequired
}